var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container login-page"},[_c('div',{staticClass:"login-header login-caret"},[_c('h1',[_vm._v(_vm._s(_vm.$t('no_cookies')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }